import type { StepInputRendererProps } from "./StepInputRenderer";

import { ContinueButton } from "./ContinueButton";
import { SubmitButton } from "./SubmitButton";

function LeadFormButtonInput({
  input,
  heroVariantStyles,
  onContinue,
  onValidateAndContinue,
  isSubmitting,
  stepName,
  stepUserSelection,
}: StepInputRendererProps) {
  if (input._type !== "formButton") {
    return null;
  }

  if (input.buttonType === "next") {
    const handleNext =
      input.validatesStep && onValidateAndContinue
        ? onValidateAndContinue
        : onContinue;
    return (
      <ContinueButton
        analyticsStepName={stepName}
        analyticsUserSelection={stepUserSelection}
        colorVariant={input.colorVariant}
        fontWeight={input.fontWeight}
        label={input.buttonLabel}
        onContinue={handleNext}
        variant={heroVariantStyles?.continueButtonVariant}
        widthVariant={input.widthVariant}
      />
    );
  }

  return (
    <SubmitButton
      colorVariant={input.colorVariant}
      fontWeight={input.fontWeight}
      isSubmitting={isSubmitting}
      label={input.buttonLabel}
    />
  );
}

export { LeadFormButtonInput };
